import {reactive, watch} from 'vue'
import moment from 'moment'

/*
 * Cola entre o CalendarForm (v-model com Date[]) e o filtro de data da API: mantém
 * date.begin / date.end em 'YYYY/MM/DD' e recarrega quando o período fica completo.
 * Os atalhos de período (hoje, ontem, este mês, mês anterior) ficam dentro do painel
 * do CalendarForm — aqui só resta o período inicial da tela (filterToday).
 */
export default function (loadDataFunction) {

    const stateCalendarFilter = reactive({
        datesInterval: null,
        date: {
            begin: '',
            end: '',
        },
    })

    watch(() => stateCalendarFilter.datesInterval, (newValue) => {

        if (!Array.isArray(newValue) || !newValue[0]) {

            stateCalendarFilter.date.begin = ''
            stateCalendarFilter.date.end = ''

            return
        }

        stateCalendarFilter.date.begin = format(newValue[0])
        stateCalendarFilter.date.end = newValue[1] ? format(newValue[1]) : ''

        // intervalo fechado (atalho do painel ou segunda data escolhida) aplica o filtro na hora;
        // com só a data inicial escolhida o painel ainda está aberto, não vale recarregar
        if (newValue[1]) {
            loadDataFunction()
        }

    })

    function format(date) {
        return moment(date).format('YYYY/MM/DD')
    }

    function filterToday() {
        stateCalendarFilter.datesInterval = [new Date(), new Date()]
    }

    return {
        stateCalendarFilter,
        filterToday
    }
}
